<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-4" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-delivery-options-1 v-bind='{...{},...{}}' :style='""' class="" ></m-delivery-options-1></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mDeliveryOptions1 from '@moeinmdn/miw-alpha-components/src/package/Dashboard/DeliveryOptions/Archive/DeliveryOptions1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mDeliveryOptions1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
